import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import config from 'config/config.js'
import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { saveUser } from 'redux/userAdmin'
import { Button, Divider, Header, Segment, Table } from 'semantic-ui-react'
import CompareField from './Segment/CompareField'

const mapStateToProps = (state, ownProps) => {
  const { userSaving } = state.userAdmin
  return { userSaving }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      saveUser,
    },
    dispatch
  )
}

class DealerCompare extends React.Component {
  componentWillReceiveProps(nextProps) {
    const { userSaving: oldUserSaving } = this.props
    const { userSaving: newUserSaving, push } = nextProps
    if (oldUserSaving && !newUserSaving) {
      push(config.nodes.dashboard)
    }
  }

  render() {
    const { user = {}, importUser = {}, push, saveUser } = this.props

    return (
      <div className="ui form">
        <ComponentHeader
          title={I18n.t('admin.dealers.compare.title')}
          customActions={[
            <Button
              labelPosition="right"
              content={I18n.t('global.cancel')}
              icon="cancel"
              secondary
              onClick={(event) => {
                push(config.nodes.dashboard)
              }}
            />,
            <Button
              labelPosition="right"
              content={I18n.t('admin.dealers.compare.action')}
              icon="checkmark"
              color="green"
              onClick={() => {
                const result = {
                  ...user,
                  ...importUser,
                  user_type: importUser.kind === 'Filiale' ? 'shop' : 'dealer',
                }
                result.id = user.id
                delete result.created_at
                delete result.updated_at
                delete result.wd_new
                delete result.wd_updated
                saveUser(result)
              }}
            />,
          ]}
        />

        <Segment attached>
          <Table basic="very" compact>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell
                  width={2}
                  content={I18n.t('admin.dealers.compare.field')}
                />
                <Table.HeaderCell
                  width={5}
                  content={I18n.t('admin.dealers.compare.old')}
                />
                <Table.HeaderCell
                  width={5}
                  content={I18n.t('admin.dealers.compare.new')}
                />
              </Table.Row>
            </Table.Header>

            <Table.Body>
              <Table.Row>
                <Table.Cell colSpan={3}>
                  <Divider hidden />
                  <Header
                    as="h3"
                    content={I18n.t('admin.dealers.compare.invoice_address')}
                  />
                </Table.Cell>
              </Table.Row>

              <CompareField
                fieldName={'Adresse 1'}
                oldValue={user.address1}
                newValue={importUser.address1}
              />
              <CompareField
                fieldName={'Adresse 2'}
                oldValue={user.address2}
                newValue={importUser.address2}
              />
              <CompareField
                fieldName={'Adresse 3'}
                oldValue={user.address3}
                newValue={importUser.address3}
              />
              <CompareField
                fieldName={'Adresse 4'}
                oldValue={user.address4}
                newValue={importUser.address4}
              />
              <CompareField
                fieldName={'Adresse 5'}
                oldValue={user.address5}
                newValue={importUser.address5}
              />
              <CompareField
                fieldName={'Adresse 6'}
                oldValue={user.address6}
                newValue={importUser.address6}
              />
              <CompareField
                fieldName={'PLZ'}
                oldValue={user.postcode}
                newValue={importUser.postcode}
              />
              <CompareField
                fieldName={'Ort'}
                oldValue={user.place}
                newValue={importUser.place}
              />
              <CompareField
                fieldName={'E-Mail'}
                oldValue={user.email}
                newValue={importUser.email}
              />

              <Table.Row>
                <Table.Cell colSpan={3}>
                  <Divider hidden />
                  <Header
                    as="h3"
                    content={I18n.t('admin.dealers.compare.coredata')}
                  />
                </Table.Cell>
              </Table.Row>

              <CompareField
                fieldName={'RK1'}
                oldValue={user.discount1}
                newValue={importUser.discount1}
              />
              <CompareField
                fieldName={'RK2'}
                oldValue={user.discount2}
                newValue={importUser.discount2}
              />
              <CompareField
                fieldName={'RK3'}
                oldValue={user.discount3}
                newValue={importUser.discount3}
              />
              <CompareField
                fieldName={'Kategorie'}
                oldValue={user.kind}
                newValue={importUser.kind}
              />
              <CompareField
                fieldName={'Zahlungsbedingungen'}
                oldValue={user.payment_terms}
                newValue={importUser.payment_terms}
              />
              <CompareField
                fieldName={'Webanzeige (WinDelta)'}
                oldValue={user.address_type}
                newValue={importUser.address_type}
              />
            </Table.Body>
          </Table>
        </Segment>
      </div>
    )
  }
}

DealerCompare = connect(mapStateToProps, mapDispatchToProps)(DealerCompare)
export default DealerCompare



// WEBPACK FOOTER //
// ./src/components/admin/Users/DealerCompare.jsx